import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowRight, BadgeCheck, Check } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/common/Reveal";
import { PageHero, CtaBand } from "@/components/site/PageHero";
import { CUSTOM_SOLUTIONS } from "@/data/products";
import { PROCESS } from "@/data/site";

export default function ConsultPage() {
  const { slug } = useParams();
  const s = CUSTOM_SOLUTIONS.find((x) => x.slug === slug);
  if (!s) return <Navigate to="/solutions" replace />;
  const quote = `/enquiry?category=${encodeURIComponent(s.name)}`;
  return (
    <div data-testid={`consult-page-${s.slug}`}>
      <PageHero eyebrow={s.kind === "service" ? "Service" : "Custom-engineered solution"} title={s.name} text={s.intro} image={s.image} cta={{ to: quote, label: s.kind === "service" ? "Book servicing" : "Request a site consultation" }} testid="consult-hero" />
      <section className="container-x py-20">
        <SectionHeading eyebrow={s.kind === "service" ? "What we do" : "System types"} title={s.kind === "service" ? "Servicing that keeps you audit-ready" : "Specified to your hazard"} />
        <div className="mt-10 grid gap-5 md:grid-cols-2">
          {s.types.map(([t, d], i) => (
            <Reveal key={t} delay={(i % 2) * 0.06}>
              <div className="card-base h-full p-7" data-testid={`consult-type-${i}`}>
                <p className="mono text-xs font-semibold text-[#C20500]">{String(i + 1).padStart(2, "0")}</p>
                <h3 className="mt-3 text-xl text-slate-900">{t}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <section className="bg-[#F4F6F2] py-20">
        <div className="container-x grid gap-10 lg:grid-cols-2">
          <div>
            <SectionHeading eyebrow="Deliverables" title="What you receive" />
            <ul className="mt-8 space-y-3">{s.deliverables.map((d) => <li key={d} className="card-base flex items-start gap-3 p-4 text-sm text-slate-800"><Check className="mt-0.5 h-4 w-4 shrink-0 text-[#C20500]" />{d}</li>)}</ul>
            <div className="mt-6 flex flex-wrap gap-2">{s.standards.map((x) => <span key={x} className="inline-flex items-center gap-1.5 rounded-full border border-emerald-300 bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-800"><BadgeCheck className="h-3.5 w-3.5" />{x}</span>)}</div>
          </div>
          <div>
            <SectionHeading eyebrow="How it works" title="From survey to sign-off" />
            <ol className="mt-8 space-y-4">
              {PROCESS.map((p) => (
                <li key={p.step} className="flex gap-4"><span className="mono text-sm font-semibold text-[#C20500]">{p.step}</span><div><p className="font-semibold text-slate-900">{p.title}</p><p className="text-sm text-slate-600">{p.text}</p></div></li>
              ))}
            </ol>
            <Link to={quote} className="btn-primary mt-8" data-testid="consult-enquiry-button">Start an enquiry <ArrowRight className="h-4 w-4" /></Link>
          </div>
        </div>
      </section>
      <CtaBand />
    </div>
  );
}
